<template>
    <div class="my-card" :class="customClass">
        <slot name="header"></slot>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Card",
    props: {
        customClass: {
            type: String,
            default: () => {
                return null
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.my-card {
    border: 2px solid rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    padding: 1.38889vw; //1.66667vw
    display: flex;
    font-family: "Exo";
    position: relative;
    font-weight: normal;
    font-size: 0.83333vw;
    line-height: calc(0.83333vw + 4px);
    color: #FFF;
}

@media screen and (min-width: 0px) and (max-width: 768px){
    .my-card {
        padding: 0;
        font-size: 12px;
        line-height: 16px;
    }
}
</style>
